import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs } from 'ws-scripts/modules/common';

import { isPrefEnabled, isPrefValueEnabled } from '../utils/prefUtils';
import NavItemList from './NavItemList';
import PanelHeader from './PanelHeader';
import SearchInput from './SearchInput';
import DrawerCTAButtons from './DrawerCTAButtons';
import DealerContactSection from './DealerContactSection';

/**
 * DrawerPanelBody — main drawer content panel.
 * Renders the header, search input, nav item list, and CTA buttons.
 * The drilldown submenu is rendered as a separate Modal by
 * NavigationDrawer, not inside this component.
 *
 * @param {DrawerPanelBodyProps} props
 * @param {string} [props.title] - Heading text for the drawer header
 * @param {React.RefObject} [props.closeRef] - Ref forwarded to the close button element
 */
const DrawerPanelBody = ({ title = '', closeRef = null }) => {
	const { enableSiteWideSearch, enableMyCars, enableMyWallet } = usePrefs();

	const showSearch = isPrefValueEnabled(enableSiteWideSearch);

	return (
		<div
			className="ws-nav-drawer__main-content d-flex flex-column flex-grow-1 overflow-auto"
			data-testid="drawer-main-content"
		>
			<div
				className="ws-nav-drawer__panel-header-outer py-4"
				data-testid="drawer-panel-header-outer"
			>
				<PanelHeader title={title} closeRef={closeRef} />
			</div>
			<div
				className="ws-nav-drawer__body d-flex flex-column flex-grow-1"
				data-testid="drawer-body"
			>
				{showSearch && <SearchInput />}
				<NavItemList />
				{(isPrefEnabled(enableMyCars) ||
					isPrefEnabled(enableMyWallet)) && <DrawerCTAButtons />}
				<DealerContactSection />
			</div>
		</div>
	);
};

DrawerPanelBody.propTypes = {
	title: PropTypes.string,
	closeRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) })
};

export default DrawerPanelBody;
